
// => Styling
import styles from './SubCollection.module.css';

// => Components
import Collapsible from '../../../components/Collapsible';
import CardsSetPreview from '../components/CardsSetPreview';

// => Data
import { boosterPacks } from '../../../content/boosterPacks';

// => React
import { useState } from 'react';


// ============
// Component
// ============
const SubCollection = ({
    onInspectCard = (d, i, s) => {},
    unlockedCards,
}) => {

    const showableBoosterSets = () => {
        return boosterPacks.filter(e => e.showInCollection === true)
    }

    const hasCardUnlocked = (set, id) => {
        if (set.unlockOverride === true) {
            return true
        }
        return unlockedCards.filter(c => c === id).length > 0
    }

    const [activeCollapsible, setActiveCollapsible] = useState(0)


    // RENDER
    // ---------
    return(
        <div className={styles.container}>

            {/* Booster sets */}
            <div className={styles.boosterSets}>
                {/* Map booster packs */}
                {showableBoosterSets().map((set, i) =>
                    <Collapsible key={"collapsible_"+set.id}
                                title={set.name}
                                open={activeCollapsible === i}
                                forceOpen={activeCollapsible === i}
                                onOpenUpdate={()=>setActiveCollapsible(i)}>
                        <CardsSetPreview data={set} hasCardUnlocked={(id)=>hasCardUnlocked(set, id)} onInspect={(d, i)=>onInspectCard(d, i, set.id)} unlockedCards={unlockedCards} />
                    </Collapsible>
                )}
            </div>
            
        </div>
    )
}


export default SubCollection